import type { OrderRosterMember } from "../types";
import type { FeeAdjustmentMember, FeeAdjustmentRecord } from "../../fee-adjustment";

type Adjustment = Pick<FeeAdjustmentRecord, "status"> & {
  members: Pick<FeeAdjustmentMember, "roster_member_id" | "receivable_delta_amount">[];
};

/** 汇总名单基准应收、已处理费用调整和当前个人应收。 */
export function calculateRosterReceivableSummary(
  members: Pick<OrderRosterMember, "id" | "isStopped" | "actualReceivableAmount">[],
  adjustments: Adjustment[],
) {
  const activeMembers = members.filter((member) => !member.isStopped);
  const activeMemberIds = new Set(activeMembers.map((member) => member.id));
  const baseCents = activeMembers.reduce(
    (sum, member) => sum + Math.round(Number(member.actualReceivableAmount || "0") * 100), 0,
  );
  const adjustmentCents = adjustments
    .filter((record) => record.status === "processed")
    .flatMap((record) => record.members)
    .filter((member) => activeMemberIds.has(member.roster_member_id))
    .reduce((sum, member) => sum + Math.round(Number(member.receivable_delta_amount || "0") * 100), 0);
  return {
    frozenRosterReceivableTotal: (baseCents / 100).toFixed(2),
    feeAdjustmentTotal: (adjustmentCents / 100).toFixed(2),
    currentRosterReceivableTotal: ((baseCents + adjustmentCents) / 100).toFixed(2),
  };
}
